import { useEffect, useState } from 'react';
import { markWasInCall } from '../../utils/returnUrl';
import useVideoContext from '../useVideoContext/useVideoContext';

type RoomStateType = 'disconnected' | 'connected' | 'reconnecting';

export default function useRoomState() {
  const { room } = useVideoContext();
  const [state, setState] = useState<RoomStateType>('disconnected');

  useEffect(() => {
    if (room) {
      const setRoomState = () => setState(room.state as RoomStateType);
      setRoomState();
      const onConnected = () => {
        markWasInCall();
        setRoomState();
      };
      room
        .on('connected', onConnected)
        .on('disconnected', setRoomState)
        .on('reconnected', setRoomState)
        .on('reconnecting', setRoomState);
      if (room.state === 'connected') {
        markWasInCall();
      }
      return () => {
        room
          .off('connected', onConnected)
          .off('disconnected', setRoomState)
          .off('reconnected', setRoomState)
          .off('reconnecting', setRoomState);
      };
    }
  }, [room]);

  return state;
}
